<template>
  <div>
    <input
      type="password"
      class="uk-input"
      autocomplete="off"
      v-model="model"
      name="password"
    />
  </div>
</template>

<script>
export default {
  name: "password",
  data() {
    return {
      model: null
    };
  },
  props: ["input", "form", "value"],
  created() {
    if (this.value) {
      this.model = this.value;
    }
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("changed", {
        name: this.input.name,
        value: this.model
      });
    }
  }
};
</script>

<style></style>
